import { FiGithub, FiLinkedin, FiMail } from "react-icons/fi";

export default function Footer() {
  return (
    <footer className="bg-terminalLight text-dimText py-8 border-t border-terminalBorder">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm font-mono">
          &copy; {new Date().getFullYear()} Abdelrahman Helal
        </p>
        <div className="flex gap-5">
          <a
            href="https://github.com/abdelrahmanhelal"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-accentBlue transition-colors"
            aria-label="GitHub"
          >
            <FiGithub size={20} />
          </a>
          <a
            href="https://linkedin.com/in/abdelrahman-helal"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-accentBlue transition-colors"
            aria-label="LinkedIn"
          >
            <FiLinkedin size={20} />
          </a>
          <a
            href="mailto:abdelrahman@uni.minerva.edu"
            className="hover:text-accentBlue transition-colors"
            aria-label="Email"
          >
            <FiMail size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
}
